<template>
  <div>
    <shimmer-recommendations
      v-if="!isLocationSettled || isLoadingTopTenBestsellerAPI"
      :type="true"
    />
    <div
      class="hb-top-10 pb20 mb12"
      :class="[isLeftTitleIconPresent ? 'pt20 left-view' : 'pt10 center-view', { [modulePropsData.titleClass]: titleClassPresent }]"
      :style="getMainComponentStyle"
      v-else-if="shouldComponentVisible && getDataItems?.length"
    >
      <div
        class="hb-top-10-heading-parent"
        :class="isLeftTitleIconPresent ? 'flex-row gap12 mb20 plr12' : 'mb15'"
      >
        <div
          :class="
            isLeftTitleIconPresent ? 'flex-column justify-content-end' : 'mb3'
          "
        >
          <img
            :src="isLeftTitleIconPresent ? leftTitleIcon : topTitleIcon"
            :style="getIconStyle"
          />
        </div>
        <div :class="isLeftTitleIconPresent ? 'tl' : ''">
          <img
            :src="titleImage"
            :style="getTitleImageStyle"
            v-if="isTitleImagePresent && !isLeftTitleIconPresent"
          />
          <span
            class="hb-top-10-heading"
            :class="isLeftTitleIconPresent ? 'mb0' : 'mb10'"
            :style="getTitleStyle"
            v-else
          >
            {{ modulePropsData?.title }}
          </span>
          <div
            v-if="getUserCity"
            class="flex-row hb-top-10-location-strip"
            :class="
              isLeftTitleIconPresent
                ? 'justify-content-start mt6'
                : 'justify-content-center plr16'
            "
            :style="{
              background: !isLeftTitleIconPresent && getSubtitleBgGradiant,
              height: isLeftTitleIconPresent ? '18px' : '30px',
            }"
          >
            <img
              class="locationIcon"
              :src="modulePropsData?.locationIcon"
              v-if="shouldLocationIconVisible"
            />
            <p class="hb-top-10-subTitle" :style="getSubTitleStyle">
              {{ getUserCity }}
            </p>
          </div>
        </div>
      </div>
      <div :class="eleClassForSlideEffect">
        <Carousel :itemsToShow="itemsToShow" :transition="500">
          <Slide v-for="(result, i) in getDataItems" :key="i">
            <product-card
              :data-cardSource="cardSource"
              :data-cardRounded="vpsProps.cardRounded"
              :data-cardSearchable="vpsProps.cardSearchable"
              :data-showUpsell="vpsProps.showUpsell"
              :data-showCrossell="vpsProps.showCrossell"
              :data-result="result"
              :data-counterText="
                'undefined-' +
                modulePropsData?.title +
                '-' +
                (i + 1) +
                '/' +
                getDataItems?.length
              "
              :marginGap="vpsProps.marginGap"
              :data-type="cardSource"
              :data-index="i"
              :key="result.code"
              :top10="shouldRibbonVisible"
              :ribbonIcon="ribbonTitleIcon"
              :ribbonTitleColor1="ribbonTitleColor1"
              :ribbonTitleColor2="ribbonTitleColor2"
              :ribbonTitle1="ribbonTitle1"
              :ribbonTitle2="ribbonTitle2"
              :isNewEventCard="true"
            ></product-card>
          </Slide>
        </Carousel>
      </div>
    </div>
    <!-- Intersection Observer -->
    <Observer :options="{ rootMargin: '-50px' }" @intersect="itisvisible" />
  </div>
</template>

<script>
import "vue3-carousel/dist/carousel.css";
import { Carousel, Slide } from "vue3-carousel";
import LocalStorageFunc from "../helpers/localStorageFunc";
import {
  keyMapsGetter,
  keyMapsAction,
  keyMapsMutation,
} from "../helpers/storeKeys";
import utility from "../helpers/utility.js";
import setEvents from "../helpers/events";
import userActivityTracking from "../helpers/UserActivityTracking";
import PageNames from "../config/pageNames";
import { defineAsyncComponent } from "vue";
import {
  VWO_NEXTGEN_HOMEPAGE_EXPERIMENT,
  VWO_NEXTGEN_EXPERIMENT_VARIANTS,
} from "../config/vwoKeys";
import ProductCard from "./ProductCard.vue";
import Observer from "../assets/Observer.vue";
import ShimmerRecommendations from "./ShimmerRecommendations.vue";
import amplitude from "amplitude-js";

export default {
  name: "HorizontalBannerTopLatest",
  props: ["moduleProps", "dataApi"],
  components: {
    Carousel,
    Slide,
    ProductCard,
    Observer,
    ShimmerRecommendations,
  },
  data() {
    return {
      data: [],
      modulePropsData: {},
      itemsToShow: 1.08,
      cardSource: "",
      vpsProps: {
        cardRounded: true,
        cardSearchable: false,
        marginGap: true,
        showUpsell: false,
        showCrossell: false,
      },
      topTitleIcon: "",
      locationIcon: "",
      leftTitleIcon: "",
      ribbonTitleIcon: "",
      ribbonTitleColor1: "",
      ribbonTitleColor2: "",
      shouldRibbonVisible: false,
      eleClassForSlideEffect: "",
      isUpdated: false,
      ribbonTitle1: "",
      ribbonTitle2: "",
      shouldLocationIconVisible: false,
      titleImage: "",
      titleClassPresent: false,
    };
  },
  mounted() {
    this.modulePropsData =
      typeof this.moduleProps != null &&
      typeof this.moduleProps != "null" &&
      typeof this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : {};

    this.itemsToShow = +this.modulePropsData?.itemsInScreen;
    this.cardSource = this.modulePropsData?.title;
    this.topTitleIcon = this.modulePropsData?.titleIconTop;
    this.locationIcon = this.modulePropsData?.locationIcon;
    if (
      this.locationIcon !== undefined &&
      this.locationIcon !== "null" &&
      this.locationIcon !== null &&
      this.locationIcon
    ) {
      this.shouldLocationIconVisible = true;
    }
    this.ribbonTitleIcon = this.modulePropsData?.ribbonIcon;
    if (
      this.ribbonTitleIcon !== undefined &&
      this.ribbonTitleIcon !== "null" &&
      this.ribbonTitleIcon !== null &&
      this.ribbonTitleIcon
    ) {
      this.shouldRibbonVisible = true;
    }
    this.leftTitleIcon = this.modulePropsData?.titleIconLeft;
    this.ribbonTitleColor1 = this.modulePropsData?.ribbonTitleColor1;
    this.ribbonTitleColor2 = this.modulePropsData?.ribbonTitleColor2;
    this.ribbonTitle1 = this.modulePropsData?.ribbonTitle1;
    this.ribbonTitle2 = this.modulePropsData?.ribbonTitle2;

    if (
      this.ribbonTitle1 === undefined ||
      this.ribbonTitle1?.toLowerCase() === "null"
    ) {
      this.ribbonTitle1 = "";
    }
    if (
      this.ribbonTitle2 === undefined ||
      this.ribbonTitle2?.toLowerCase() === "null"
    ) {
      this.ribbonTitle2 = "";
    }

    if (this.modulePropsData?.animation?.toLowerCase() === "on") {
      this.eleClassForSlideEffect = (
        "_" +
        this.modulePropsData?.title +
        "_" +
        this.modulePropsData?.name
      )
        .replaceAll(" ", "_")
        .trim()
        .toLowerCase();
    }

    this.titleImage = this.modulePropsData?.titleImage;
    this.titleClassPresent = !!this.modulePropsData?.titleClass;
  },
  watch: {
    isUpdated: {
      handler(newVal, oldVal) {
        if (
          newVal === true &&
          this.eleClassForSlideEffect !== undefined &&
          this.eleClassForSlideEffect !== "null" &&
          this.eleClassForSlideEffect != ""
        ) {
          setTimeout(() => {
            document
              .querySelector(
                ".hb-top-10 ." +
                  this.eleClassForSlideEffect +
                  " .carousel__track"
              )
              ?.setAttribute(
                "style",
                "transition:all 500ms ease 0s;transform:translateX(-150px) !important"
              );

            let eleIs = document.querySelector(
              ".hb-top-10 ." + this.eleClassForSlideEffect + " .carousel__track"
            );
            setTimeout(() => {
              if (eleIs) {
                eleIs.style.transform = "translateX(0px)";
              }
            }, 800);
          }, 500);
        }
      },
    },
  },
  methods: {
    itisvisible() {
      if (!this.isUpdated && this.getDataItems?.length > 0) {
        this.isUpdated = true;
      }
    },
    apiTopTen() {
      let dataApiConstruct = this.dataApi.split("?")[0];
      if (
        dataApiConstruct !== undefined &&
        dataApiConstruct !== null &&
        dataApiConstruct != false
      ) {
        let userFreq = LocalStorageFunc.getUserData()?.userData?.frequency;
        let payloadObj = utility.getQueryFromUrl(this.dataApi);
        this.$store.dispatch(keyMapsAction.GET_MULTIPLE_RECOMMENDATION_DATA, {
          api: dataApiConstruct,
          apiPayload: {
            sequenceSet: this.modulePropsData?.sequenceSet || "",
            name: this.modulePropsData?.name || "",
            limit: this.modulePropsData?.limit || "",
            userFrequency: userFreq ? userFreq : "",
            platform: "pwa",
          },
          payloadObj
        });
      }
    },
    titleCase(str) {
      var splitStr = str.toLowerCase().split(" ");
      for (var i = 0; i < splitStr.length; i++) {
        splitStr[i] =
          splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      return splitStr.join(" ");
    },
  },
  computed: {
    getDataItems() {
      const { name, sequenceSet } = this.modulePropsData;
      let key = name ? name : "";
      if (sequenceSet) {
        key = key + "_" + sequenceSet;
      }

      let data = this.$store.state.MultipleRecommendation[key] || [];
      return data;
    },

    getTitleStyle() {
      let _;
      let color1 = this.modulePropsData?.titleColor1;
      let color2 = this.modulePropsData?.titleColor2;

      if (color1 && color2 && color1 !== "null" && color2 !== "null") {
        _ = {
          background:
            "linear-gradient(160.86deg, " +
            this.modulePropsData?.titleColor1 +
            " 4.88%, " +
            this.modulePropsData?.titleColor2 +
            " 71.26%)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          backgroundClip: "text",
          textFillColor: "trasparent",
        };
      } else {
        _ = {
          color: color1 || color2,
        };
      }

      return _;
    },

    getComponentBgColor() {
      let _;
      if (
        this.modulePropsData?.backgroundImage !== undefined &&
        this.modulePropsData?.backgroundImage !== null &&
        this.modulePropsData?.backgroundImage !== "null"
      ) {
        _ = this.modulePropsData?.backgroundImage;
      } else {
        _ =
          "linear-gradient(180deg, " +
          this.modulePropsData?.bgGradientColor1 +
          "33" +
          " 0%, " +
          this.modulePropsData?.bgGradientColor2 +
          "6B" +
          " 51.56%, " +
          this.modulePropsData?.bgGradientColor3 +
          "00" +
          " 100%)";
      }
      return _;
    },

    getMainComponentStyle() {
      let background = this.getComponentBgColor;
      let borderTop = this.modulePropsData?.topBorder;
      let borderBottom = this.modulePropsData?.bottomBorder;
      let borderColor = this.modulePropsData?.borderColor;
      if (
        borderColor === undefined ||
        borderColor === "null" ||
        borderColor === null ||
        !borderColor
      ) {
        borderColor = "#f1f1f1";
      }

      let bgRelatedProperty = {
        background : background
      };

      if (background?.includes("http")) {
        if(this.isLeftTitleIconPresent){
          bgRelatedProperty = {
            background : `left/cover no-repeat url(${background})`
          }
        }
        else{
          bgRelatedProperty ={
            background: `center/cover url(${background})`,
            backgroundRepeat: `no-repeat`,
          }
        }
      }

      let _ = {
        ...bgRelatedProperty,
        borderTop: borderTop ? borderTop + "px solid" : 0,
        borderBottom: borderBottom ? borderBottom + "px solid" : 0,
        borderColor: borderColor,
      };

      return _;
    },

    getSubtitleBgGradiant() {
      let _ =
        "linear-gradient(270.02deg, " +
        this.modulePropsData?.subTitleGradientColor1 +
        "00" +
        " 0.02%, " +
        this.modulePropsData?.subTitleGradientColor2 +
        " 49.58%, " +
        this.modulePropsData?.subTitleGradientColor3 +
        "00" +
        " 97.13%)";
      return _;
    },

    getSubTitleStyle() {
      let color1 = this.modulePropsData?.subTitleColor1;
      let color2 = this.modulePropsData?.subTitleColor2;

      let _;
      if (color1 && color2 && color1 !== "null" && color2 !== "null") {
        _ = {
          background:
            "linear-gradient(160.86deg, " +
            this.modulePropsData?.subTitleColor1 +
            " 4.88%, " +
            this.modulePropsData?.subTitleColor2 +
            " 71.26%)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          backgroundClip: "text",
          textFillColor: "trasparent",
        };
      } else {
        _ = {
          color: color1 || color2,
        };
      }
      return _;
    },

    isLeftTitleIconPresent() {
      if (
        this.modulePropsData?.titleAlignment?.toLowerCase() === "left" &&
        this.leftTitleIcon !== undefined &&
        this.leftTitleIcon !== null &&
        this.leftTitleIcon !== "null"
      ) {
        return true;
      } else {
        return false;
      }
    },

    getUserCity() {
      let { city } = this.$store.state.Location.storeDetails;
      let subTitle = this.modulePropsData?.subTitle;
      let defaultSubTitle = this.modulePropsData?.defaultSubtitle;
      let userName = LocalStorageFunc.getUserData()?.userData?.firstName;

      if (
        subTitle !== undefined &&
        subTitle !== null &&
        subTitle !== "null" &&
        subTitle
      ) {
        if (
          subTitle?.includes(":locationName") &&
          city !== undefined &&
          city !== null &&
          city
        ) {
          return "In " + this.titleCase(city);
        } else if (
          subTitle?.includes(":userName") &&
          LocalStorageFunc.isLoggedIn() &&
          userName
        ) {
          return subTitle?.replace(":userName", userName);
        } else {
          return defaultSubTitle;
        }
      } else {
        return defaultSubTitle;
      }
    },

    shouldComponentVisible() {
      let userProperty = this.modulePropsData?.userSupportType;
      let validOptions = userProperty ? userProperty?.split("$") : [];
      let userFrequency = LocalStorageFunc.getUserData()?.userData?.frequency;
      let isUserLoggedIn = LocalStorageFunc.isLoggedIn();
      let optionPresent = [];

      if (!isUserLoggedIn) {
        optionPresent.push("NL");
      }

      if (
        userFrequency !== undefined &&
        userFrequency !== null &&
        userFrequency != ""
      ) {
        optionPresent.push(userFrequency);
      }

      // if(this.previousOrderPizzaLength === 0 && isUserLoggedIn){
      //   optionPresent.push('N');
      // }else if(this.previousOrderPizzaLength === 1){
      //   optionPresent.push('S')
      // }

      const matchFound = validOptions.some(
        (r) => optionPresent.indexOf(r) >= 0
      );

      const moduleNameString =
        "NGH_MODULE_" +
        this.modulePropsData?.title?.trim()?.toUpperCase().replaceAll(" ", "_");

      amplitude.setUserProperties({
        [moduleNameString]:
          matchFound && this.getDataItems?.length ? "visible" : "not visible",
      });

      return matchFound;
    },
    isLocationSettled() {
      let _ = this.$store.state.Location.isLocationSettled;
      if (_) {
        this.apiTopTen();
      }
      return _;
    },
    isLoadingTopTenBestsellerAPI() {
      return this.$store.state.MultipleRecommendation
        .isLoadingTopTenBestsellerAPI;
    },
    previousOrderPizzaLength() {
      return this.$store.state.ReOrder.previousOrderData?.length;
    },
    getIconStyle() {
      let maxHeight = this.modulePropsData?.iconMaxHeight;
      let _ = {
        maxHeight: maxHeight + "px !important",
      };

      return _;
    },
    isTitleImagePresent() {
      if (
        this.modulePropsData?.titleImage !== undefined &&
        this.modulePropsData?.titleImage !== null &&
        this.modulePropsData?.titleImage !== "null"
      ) {
        return true;
      } else {
        return false;
      }
    },
    getTitleImageStyle() {
      let maxHeight = this.modulePropsData?.titleImageMaxHeight;
      let _ = {
        maxHeight: maxHeight + "px !important",
      };
      return _;
    },
  },
};
</script>

<style scoped></style>
